import React from 'react'
// import Icon from '../Icon'
import './SmileySelector.scss'
import { SmileyFrust, SmileyHappy, SmileyLike, SmileyNeutral, SmileySad } from '../../icons/Icons';

/**
 *
 * @param {Object} props
 * @param {string=} props.className
 */
function SmileySelector(props) {
  const { selection, setSelection } = props

  return (
    <div className={`SmileySelector ${selection ? 'selection-made' : 'no-selection-made'}`} data-testid="SmileySelector">
      <SmileyOption id={1} selectedId={selection} onSelect={setSelection} />
      <SmileyOption id={2} selectedId={selection} onSelect={setSelection} />
      <SmileyOption id={3} selectedId={selection} onSelect={setSelection} />
      <SmileyOption id={4} selectedId={selection} onSelect={setSelection} />
      <SmileyOption id={5} selectedId={selection} onSelect={setSelection} />
    </div>
  )
}

const getIcon = (selectedId) => {
  switch (selectedId) {
    case 1:
      return <SmileyFrust />
  
    case 2:
      return <SmileySad />
  
    case 3:
      return <SmileyNeutral />
  
    case 4:
      return <SmileyHappy />
  
    case 5:
      return <SmileyLike />
  
    default:
      break;
  }
}

function SmileyOption(props) {
  const { id, selectedId, onSelect } = props

  const isSelected = selectedId === id

  return (
    <div
      className={`SmileyOption ${isSelected || !selectedId ? 'selected' : 'not-selected'}`}
      onClick={() => onSelect(id)}
    >
      { getIcon(id) }
    </div>
  )
}

export default SmileySelector
